<template>
    <div>
        <h2><strong style="color:#1A0054">Perfil</strong></h2>
        <div class="mb-5 bg-white rounded px-lg-5 px-md-5 px-sm-2 pt-4">

            <h4 class="mx-4"><strong>Detalle del usuario</strong></h4>

            <div class="bg-utel-v2-secondary p-3 mb-2 mt-4 rounded-8 mx-4 table-responsive">
                <table class="table table-borderless text-table-profile">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Correo</th>
                            <th>Celular</th>
                            <th>Cargo</th>
                            <th>Área</th>
                            <th>Nivel</th>
                            <th rowspan="2" class="align-middle text-center"><button class="btn bg-white sin-borde text-primary rounded-8" @click.prevent="showModalEditStudent">Editar información</button></th>
                            <!--<th rowspan="2" class="align-middle text-center"><button class="btn bg-white sin-borde text-primary rounded-8" @click.prevent="showModalDeleteStudent">Eliminar usuario</button></th>-->
                        </tr>
                        <tr>
                            <td>{{ user.firstname }} {{ user.lastname }}</td>
                            <td>{{ user.email }}</td>
                            <td>{{ user.cellphone }}</td>
                            <td>{{ user.position }}</td>
                            <td>{{ user.area }}</td>
                            <td>{{ user.level }}</td>
                        </tr>
                    </thead>
                </table>
            </div>

            <h4 class="mx-4 my-4"><strong>Plan Empresarial</strong></h4>

            <div class="row mx-4 my-4 text-table-profile">
                <div class="col-lg-4 col-md-3 col-sm-12 border rounded-8 pt-4 mt-3">
                    <div>
                        <p>Plan actual<br>
                        <strong style="color:#1A0054; font-size: 18px;">{{ license.name }}</strong><br></p>
                    </div>
                    <div>
                        <p>Características<br>
                        <i class="fa fa-book-open" aria-hidden="true"></i> Acceso a todos los cursos<br>
                        <i class="fa fa-users" aria-hidden="true"></i> {{ license.accepted_users }} usuarios<br>
                        <i class="fa fa-calendar" aria-hidden="true"></i> Duración de {{ getDuracion() }}</p>
                    </div>                    
                    <hr>
                    <div class="col-12 rounded-8 bg-utel-v2-secondary table-responsive">
                        <p>Consumo</p>
                        <table class="table text-table-profile">
                            <tr>
                                <td><i class="fa fa-users" aria-hidden="true"></i> {{ license.accepted_users }} usuarios</td>
                                <td style="width: 5px;"> </td>
                                <td><i class="fa fa-calendar" aria-hidden="true"></i> Duración de {{ getDuracion() }}</td>
                            </tr>
                            <tr>
                                <td class="text-center rounded-8 bg-white p-1">{{ datalicense.usuariosActivos }} usuarios Activos</td>
                                <td style="width:5px"> </td>
                                <td class="text-center rounded-8 bg-white p-1">{{ datalicense.duracionRestante  }} restantes</td>
                            </tr>
                        </table>
                        <div class="text-center">
                            <a href="https://wa.me/+5215592522981" target="_blank" class="btn btn-primary text-white d-block rounded-8" style="font-size: 14px">Mejorar Plan</a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8 col-md-9 col-sm-12">
                    <div class="bg-image">
                        <a href="https://wa.me/+5215592522981" target="_blank"><img src='/images/banner_utel_26092023.jpg' class="w-100" /></a>
                    </div>
                </div>
            </div>

        </div>
        <modaleditar v-if="isModalEditVisible" @close="closeModalEditarStudent" :student="user" :url="urleditar" :from="'profile'" />
    </div>
</template>

<script>
import modaleditar from '../students/ModalEditStudent.vue';
export default {
    props: ["user", "client", "urleditar", "license", "datalicense"],
    components: {
        modaleditar
    },
    data: function () {
        return {
            isModalEditVisible: false,
        }
    },
    mounted() {
        
    },
    methods: {
        showModalEditStudent() {
            this.isModalEditVisible = true;
        },
        closeModalEditarStudent() {
            this.isModalEditVisible = false;
        },
        getDuracion(){
            let duracion = this.license.expiration_date;
            console.log(duracion);
            duracion = duracion.replace("years", "año(s)");
            console.log(duracion);
            duracion = duracion.replace("month", "mes(es)");
            duracion = duracion.replace("days", "día(s)");
            duracion = duracion.replace("hours", "hora(s)");
            return duracion;
        }
    }
}
</script>

<style>
.text-table-profile {
    font-size: 14px;
    color: #1A0054;
}
</style>